export const aliasHidden = [
    'question_accepted_term',
    'question_late-term_acceptance',
    'question_accepted_contact'
];

export const quizHiddenAZ = [
    "fazbemquiz",
    "fasenra",
    "saphnelo",
    "tezspire",
    "nestlequiz",
    "adiumquiz"
]

export const caregiverApiAlias = [
    "question_caregiver_name",
    "question_caregiver_cpf",
    "question_caregiver_gender",
    "question_caregiver_birthdate",
    "question_caregiver_email",
    "question_caregiver_relationship",
    "question_caregiver_zipcode",
    "question_caregiver_state",
    "question_caregiver_city",
    "question_caregiver_areacodephone",
    "question_caregiver_phone",
    "question_caregiver_areacodecellphone",
    "question_caregiver_cellphone",
    "question_caregiver_emailoptin",
    "question_caregiver_whatsappoptin",
    "question_caregiver_calloptin",
    "question_caregiver_consentterm",
    "question_caregiver_address",
    "question_caregiver_number",
    "question_caregiver_district",
    "question_caregiver_addresscomplement",
]


export const caregiverApiAliasHidden = [
    "question_caregiver_areacodecellphone",
    "question_caregiver_areacodephone",
    // "question_caregiver_address",
    // "question_caregiver_number",
    // "question_caregiver_district",
    // "question_caregiver_addressComplement",
]


export const quizCaregiverHidden = [
    "question_late-term_acceptance",
    "question_patient_calloptin",
    "question_patient_whatsappoptin",
    "question_patient_emailoptin"
]

export const checkBoxesCaregiverHidden = [
    "question_caregiver_consentterm" //validar isso
]

export const checkBoxesBeneficiaryHidden = [
    "question_late-term_acceptance",
    'question_accepted_term'
    
]

export const addressCaregiver = ['question_caregiver_zipcode', 
'question_caregiver_city', 
'question_caregiver_address', 
'question_caregiver_number',
'question_caregiver_district',
'question_caregiver_addresscomplement']

export const fieldsCaregiverNotRequired = [
    'question_caregiver_addresscomplement',
    'question_caregiver_phone'
]

export const FAZ_BEM_ID = 165627
export const NESTLE_ID = 263326
export const SERVIER_ID = 297026
export const FACILITA_DIABETES_ID = 120325
export const VIVER_ADIUM_ID = 286626
export const acceptanceTermEmailOnlyBenefitIds = [NESTLE_ID, SERVIER_ID, VIVER_ADIUM_ID]

// Planos em que o aceite do regulamento implica aceite de contato = 7 (todos os canais)
export const contactAcceptanceBenefitIds = [FACILITA_DIABETES_ID, VIVER_ADIUM_ID]
